import { useTranslation } from "react-i18next";
import { CONSENT_ITEMS } from "../legal/consentItems";
import { ConsentRow } from "../legal/ConsentRow";

// موافقات صريحة منفصلة لكل مستند (شرط مراجعة آبل وجوجل).
export const ConsentBox = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-3" data-testid="consent-box">
      {CONSENT_ITEMS.map((item) => (
        <ConsentRow
          key={item.id}
          id={item.id}
          checked={Boolean(value[item.id])}
          onChange={(v) => onChange({ ...value, [item.id]: v })}
          label={t(item.label)}
          hint={t(item.hint)}
          to={item.to}
          linkLabel={t(item.link)}
        />
      ))}
      <p className="text-[11px] leading-5 text-muted-foreground">{t("legal.biometricNote")}</p>
    </div>
  );
};
